export default "__VITE_ASSET__x$RCKUmD__"